import { isProduction } from '@/libs/getEnvironment';

export const TOP_GAMES_CATEGORY_ID = isProduction()
  ? '8614a166-259a-42a5-b028-38c979226615'
  : '7f49c58a-5f65-4d25-84e3-aef4c67102f9';
